module.exports = __webpack_public_path__ + "static/media/sfij-frontpage.782a91f2.png";